// extracted by mini-css-extract-plugin
export default {"container":"yH9RynDEZ0Pc6nq5qvDx","item":"RioWMG46CJVRvRaN5IK0","title":"hmIij3d4c1OzePp5h2sb","body":"dbycRDq3wjE1p3oky_Uf","footer":"tsLG6RBbKLrn2kSqzeNM"};